/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Tips_LabelInputs */

const en_negotiation_tips_label = /** @type {(inputs: Negotiation_Tips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips`)
};

const de_negotiation_tips_label = /** @type {(inputs: Negotiation_Tips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips`)
};

const fr_negotiation_tips_label = /** @type {(inputs: Negotiation_Tips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips`)
};

const es_negotiation_tips_label = /** @type {(inputs: Negotiation_Tips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips`)
};

const it_negotiation_tips_label = /** @type {(inputs: Negotiation_Tips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips`)
};

const nl_negotiation_tips_label = /** @type {(inputs: Negotiation_Tips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips`)
};

const pl_negotiation_tips_label = /** @type {(inputs: Negotiation_Tips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips`)
};

const fi_negotiation_tips_label = /** @type {(inputs: Negotiation_Tips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips`)
};

const da_negotiation_tips_label = /** @type {(inputs: Negotiation_Tips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips`)
};

const sv_negotiation_tips_label = /** @type {(inputs: Negotiation_Tips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips`)
};

/**
* | output |
* | --- |
* | "Tips" |
*
* @param {Negotiation_Tips_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_tips_label = /** @type {((inputs?: Negotiation_Tips_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Tips_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_tips_label(inputs)
	if (locale === "fr") return fr_negotiation_tips_label(inputs)
	if (locale === "es") return es_negotiation_tips_label(inputs)
	if (locale === "it") return it_negotiation_tips_label(inputs)
	if (locale === "nl") return nl_negotiation_tips_label(inputs)
	if (locale === "pl") return pl_negotiation_tips_label(inputs)
	if (locale === "fi") return fi_negotiation_tips_label(inputs)
	if (locale === "da") return da_negotiation_tips_label(inputs)
	if (locale === "sv") return sv_negotiation_tips_label(inputs)
	return en_negotiation_tips_label(inputs)
});